/* tslint:disable */
/* eslint-disable */
/**
 * RakuLogi API
 * RakuLogi の API ドキュメント
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RequestItem
 */
export interface RequestItem {
    /**
     * 
     * @type {string}
     * @memberof RequestItem
     */
    expirationDate?: string;
    /**
     * 
     * @type {number}
     * @memberof RequestItem
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof RequestItem
     */
    msku?: string;
    /**
     * 
     * @type {number}
     * @memberof RequestItem
     */
    quantity?: number;
}

/**
 * Check if a given object implements the RequestItem interface.
 */
export function instanceOfRequestItem(value: object): value is RequestItem {
    return true;
}

export function RequestItemFromJSON(json: any): RequestItem {
    return RequestItemFromJSONTyped(json, false);
}

export function RequestItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): RequestItem {
    if (json == null) {
        return json;
    }
    return {
        
        'expirationDate': json['expiration_date'] == null ? undefined : json['expiration_date'],
        'id': json['id'] == null ? undefined : json['id'],
        'msku': json['msku'] == null ? undefined : json['msku'],
        'quantity': json['quantity'] == null ? undefined : json['quantity'],
    };
}

export function RequestItemToJSON(json: any): RequestItem {
    return RequestItemToJSONTyped(json, false);
}

export function RequestItemToJSONTyped(value?: RequestItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'expiration_date': value['expirationDate'],
        'id': value['id'],
        'msku': value['msku'],
        'quantity': value['quantity'],
    };
}

